// extracted by mini-css-extract-plugin
module.exports = {"removeUnderline":"Link_removeUnderline__efxVv"};